module.exports = __webpack_public_path__ + "static/media/bg.18081c68.svg";